/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, May 2023
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Pie } from 'react-chartjs-2';
import { Paper } from '@material-ui/core';
import useStyles from './useStyles';

const PieChart = ({ data, title, formatter }) => {
  const classes = useStyles();
  return (
    <Paper className={classes.paper} elevation={0}>
      <Pie
        data={data}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              display: true,
              position: 'right',
            },
            title: {
              display: true,
              position: 'top',
              color: 'rgba(0, 0, 0, 0.54)',
              text: title,
              fullSize: true,
              font: {
                size: 14,
                weight: 400,
              },
            },
            // datalabels: {
            //   formatter: function (value, context) {
            //     // const label = context.chart.data.labels[context.dataIndex];
            //     return `${value}%`;
            //   }
            // }
            datalabels: {
              formatter: formatter,
            }
          },
        }}
      />
    </Paper>
  );
};

export default PieChart;

PieChart.propTypes = {
  data: PropTypes.object.isRequired,
  title: PropTypes.string,
  formatter: PropTypes.func,
};

PieChart.defaultProps = {
  data: {
    labels: [],
    datasets: []
  },
  title: '',
  formatter: (value, context) => { },
};
